const formatCurrency = (value = 0) => {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    maximumFractionDigits: 0,
  }).format(Number(value) || 0);
};

const SummaryBox = ({ title, data }) => {
  const safe = data || {
    docs_count: 0,
    gross_income_total: 0,
    net_income_total: 0,
    tax_withheld_total: 0,
  };

  return (
    <div className="rounded-xl border border-slate-200 p-4">
      <h3 className="mb-4 text-sm font-semibold text-slate-800">{title}</h3>

      <div className="space-y-3">
        <div className="flex items-center justify-between gap-4">
          <span className="text-sm text-slate-500">Docs Count</span>
          <span className="text-sm font-medium text-slate-900">{safe.docs_count}</span>
        </div>

        <div className="flex items-center justify-between gap-4">
          <span className="text-sm text-slate-500">Gross Income</span>
          <span className="text-sm font-medium text-slate-900">
            {formatCurrency(safe.gross_income_total)}
          </span>
        </div>

        <div className="flex items-center justify-between gap-4">
          <span className="text-sm text-slate-500">Net Income</span>
          <span className="text-sm font-medium text-slate-900">
            {formatCurrency(safe.net_income_total)}
          </span>
        </div>

        <div className="flex items-center justify-between gap-4">
          <span className="text-sm text-slate-500">Tax Withheld</span>
          <span className="text-sm font-medium text-slate-900">
            {formatCurrency(safe.tax_withheld_total)}
          </span>
        </div>
      </div>
    </div>
  );
};

const TaxYearSummaryCard = ({ data }) => {
  if (!data) return null;

  const finalSummary = data.summary_by_sifat?.FINAL;
  const nonFinalSummary = data.summary_by_sifat?.['TIDAK FINAL'];

  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-slate-900">Tax Year Summary</h2>
        <p className="text-sm text-slate-500">
          Ringkasan dokumen FINAL dan TIDAK FINAL untuk tahun pajak.
        </p>
      </div>

      <div className="mb-5 grid gap-4 md:grid-cols-3">
        <div className="rounded-xl bg-slate-50 border border-slate-200 p-4">
          <p className="text-xs uppercase tracking-wide text-slate-500">Taxpayer</p>
          <p className="mt-2 text-base font-semibold text-slate-900">
            {data.taxpayer_name || '-'}
          </p>
        </div>

        <div className="rounded-xl bg-slate-50 border border-slate-200 p-4">
          <p className="text-xs uppercase tracking-wide text-slate-500">PTKP Status</p>
          <p className="mt-2 text-base font-semibold text-slate-900">
            {data.ptkp_status || '-'}
          </p>
        </div>

        <div className="rounded-xl bg-slate-50 border border-slate-200 p-4">
          <p className="text-xs uppercase tracking-wide text-slate-500">PTKP Amount</p>
          <p className="mt-2 text-base font-semibold text-slate-900">
            {formatCurrency(data.ptkp_amount)}
          </p>
        </div>
      </div>

      <div className="grid gap-4 lg:grid-cols-2">
        <SummaryBox title="FINAL" data={finalSummary} />
        <SummaryBox title="TIDAK FINAL" data={nonFinalSummary} />
      </div>
    </section>
  );
};

export default TaxYearSummaryCard;